import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FloatingButton } from "../components/FloatingButton";
import { HomeCards } from "../components/HomeCards";
import TransactionItem from "../components/TransactionItem";
import Button from "../components/Button";
import { useFunds } from "../service";

const transactions = [
  {
    id: 1,
    type: "withdraw",
    description: "From Crypto",
    amount: -53.95,
    date: "March 14, 2021",
    month: "March 2025",
  },
  {
    id: 2,
    type: "deposit",
    description: "From Crypto",
    amount: 2500.95,
    date: "April 14, 2021",
    month: "March 2025",
  },
  {
    id: 3,
    type: "deposit",
    description: "Coffe with Sarah",
    amount: 5.42,
    date: "April 12, 2021",
    month: "March 2025",
  },
  {
    id: 4,
    type: "plan_activation",
    description: "Starter Plan",
    amount: 999.0,
    date: "April 09, 2021",
    month: "March 2025",
  },
  {
    id: 5,
    type: "withdraw",
    description: "From Crypto",
    amount: -53.95,
    date: "March 14, 2021",
    month: "February 2025",
  },
  {
    id: 6,
    type: "exchange",
    description: "ETH to USD",
    amount: 2500.95,
    date: "April 14, 2021",
    month: "February 2025",
  },
  {
    id: 7,
    type: "deposit",
    description: "Coffe with Sarah",
    amount: 5.42,
    date: "April 12, 2021",
    month: "February 2025",
  },
  {
    id: 8,
    type: "plan_activation",
    description: "Starter Plan",
    amount: 999.0,
    date: "April 09, 2021",
    month: "February 2025",
  },
];

export const Home = () => {
  const [accountActivity, setAccountActivity] = useState([]);
  const [fundDatas, setFundDatas] = useState([...transactions]);

  const { data: funds, refetch: getfunds } = useFunds()?.funds;

  useEffect(() => {
    getfunds();
    const fetchAccountActivity = () => {
      setAccountActivity([
        {
          id: 1,
          title: "Withdrawal of funds",
          status: "Successful",
          date: "14th March",
        },
      ]);
    };
    fetchAccountActivity();
  }, []);

  useEffect(() => {
    if (funds && funds.length > 0) {
      setFundDatas(funds);
    }
  }, [funds]);

  return (
    <div style={{ padding: "5px" }}>
      <div
        className="px-10"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          overflow: "show",
        }}
      >
        <HomeCards />
      </div>
      <FloatingButton />

      <div className="content my-0 mt-3 px-1 mt-4">
        <div className="d-flex">
          <div className="align-self-center">
            <h3
              className="font-20 font-700 mb-2"
              style={{
                color: "#fff",
              }}
            >
              Recent Activity
            </h3>
          </div>
          <div className="align-self-center ms-auto">
            <Link
              to={"/activity"}
              className="font-13 font-600 pt-1"
              style={{ color: "rgba(44, 42, 209, 1)" }}
            >
              View All
            </Link>
          </div>
        </div>
      </div>
      <div style={{ padding: "0 10px", marginTop: "10px" }}>
        {fundDatas.map((transaction) => (
          <TransactionItem key={transaction.id} transaction={transaction} />
        ))}
      </div>
    </div>
  );
};
